import React from 'react'
import styled from '@emotion/styled'
import {css} from '@emotion/core'

import {getCountryCodeFromLanguage} from '@daedalus/core/src/localization/services/country'

import Button from '../../../../designSystem/Button'
import Flag from '../../../../designSystem/Flag'

interface Props {
  currency: string
  language: string
  hasCurrency?: boolean
  onClick: () => void
}

const CurrencyWrapper = styled('span')(
  ({theme}) => css`
    margin-left: ${theme.layout.spacing.s300}px;
  `
)

export const PreferencesLink = ({
  currency,
  language,
  hasCurrency = true,
  onClick
}: Props) => {
  const countryCode = getCountryCodeFromLanguage(language)

  return (
    <Button appearance="buttonLink" onClick={onClick}>
      <Flag countryCode={countryCode} />
      {hasCurrency && <CurrencyWrapper>{currency}</CurrencyWrapper>}
    </Button>
  )
}
